export default __webpack_public_path__ + "static/media/kenya_icon.96202635.png";